<template>
  <div>

    <div v-if="isLoading"
         class="pt-5">
      <v-skeleton-loader
          class="mx-auto my-3"
          width="70vw"
          type="list-item-avatar"
          v-for="i in 4"
          :key="i"
      ></v-skeleton-loader>
    </div>

    <div v-else>

      <!-- pipeline progress -->
      <v-progress-linear
        :value="pipeline.progress"
        :color="pipeline.isCompleted ? 'success' : 'primary'"
      ></v-progress-linear>

      <!-- pipeline actions -->
      <v-container class="pt-5">
        <Explorer :pipeline="pipeline"
                  @completed="onActionCompleted"
                  ref="explorer"/>
      </v-container>
      
    </div>

  </div>
</template>

<script>
import API from '@/api'

import { mapMutations } from 'vuex'

import utility from '@/mixins/utility'
import withId from '@/mixins/withId'

import Explorer from '@/components/Pipeline/Explorer'

export default {
  
  name: 'Pipeline',

  mixins: [ utility, withId ],

  components:
  {
    Explorer
  },

  data: () => ({
    isLoading: false,
    pipeline: {}
  }),

  computed:
  {
    
  },

  methods: 
  {
    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    load()
    {
      let pipelineParam = this.$route.params.pipeline
          if(pipelineParam)
            this.pipeline = pipelineParam

      this.isLoading = true

      const args = { include:'actions,actions.provider' }

      const ws = API.pipeline.one( this.idParam, args )
                              .then(({ data })=>{
                                this.pipeline = this.mapModel(data.data, 'pipeline')
                              })
                              .finally(()=>this.isLoading = false)

      return ws
    },

    onActionCompleted(data)
    {
      const actionId = data.action.id

      this.load()
          .then(()=>{

            this.pipeline.actions.forEach((action)=>{
              if(action.id === actionId)
                this.$refs.explorer.setCurrentAction(action)
            })

          })
    },

  },

  mounted()
  {
    this.load()
  },

  watch:
  {
    isLoading()
    {
      //this.setLoading(value)
    }
  }

}
</script>
